import * as actionsLog from '../app/modules/UsersActions/_redux/usersActionsActions';
import {results} from '../app/modules/_common/constants/results';

export const logUserAction = (
  page,
  subject,
  action,
  payload = '',
  errorCode,
) => {
  actionsLog.logUserAction(
    page,
    subject,
    action,
    payload,
    errorCode === 0 ? results.SUCCESS : results.FAIL
  );
};